import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function TrendingGrid() {
  const featured = featuredArticles.slice(0, 3);
  const mainArticle = featured[0];
  const sideArticles = featured.slice(1, 3);

  return (
    <section className="bg-background-50 py-16 md:py-20" aria-labelledby="trending-title">
      <div className="w-full px-6 md:px-10">
        {/* Header: asymmetric layout */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-10">
          <h2 id="trending-title" className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight lg:max-w-sm">
            热门爆料
            <br />
            精选
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md leading-relaxed lg:text-right">
            精选当日最具话题性的黑料爆料，涵盖明星、网红、娱乐圈各大热点事件，让你一次吃够瓜。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {/* Main large card */}
          {mainArticle && (
            <Link
              to={`/article/${mainArticle.id}`}
              className="lg:col-span-1 group cursor-pointer rounded-lg overflow-hidden relative bg-primary-900 h-[400px] md:h-[500px]"
            >
              <img
                src={mainArticle.imageUrl}
                alt={mainArticle.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500/80 text-white text-xs font-medium mb-3 whitespace-nowrap">
                  {mainArticle.categoryName}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white leading-snug mb-2">
                  {mainArticle.title}
                </h3>
                <p className="text-sm text-white/60 line-clamp-2">{mainArticle.excerpt}</p>
              </div>
            </Link>
          )}

          {/* Side cards */}
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {sideArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group cursor-pointer rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-300/50 transition-all duration-300"
              >
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                      <i className="ri-fire-line text-xs"></i>
                      {article.categoryName}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {formatNumber(article.views)}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {formatNumber(article.comments)}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function formatNumber(n: number): string {
  if (n >= 10000) return (n / 10000).toFixed(1) + '万';
  if (n >= 1000) return (n / 1000).toFixed(1) + 'k';
  return String(n);
}